import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
  margin-bottom: 40px;
`;
const List = styled.ul`
  list-style-type: none;
  padding: 0;
`;
const ListItem = styled.li`
  color: ${p => p.theme.color.textPrimary};
  font-size: 12px;
  font-style: italic;
  margin-bottom: 0.6rem;

  &::before {
    content: '*';
    margin-right: 5px;
    position: relative;
    top: 2px;
  }
`;

const processString = string => string.split('\n');

const Footnote = ({ footnotes }) => (
  <Wrapper>
    <List>
      {processString(footnotes).map((line, index) => (
        <ListItem key={index}>{line}</ListItem>
      ))}
    </List>
  </Wrapper>
);

Footnote.propTypes = {
  footnotes: PropTypes.string
};

export default Footnote;
